module.exports = __webpack_public_path__ + "img/face-black.8e9b0bf6.svg";